var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "_flexcol _gap-3" },
    [
      _vm.title
        ? _c("base-title", { attrs: { as: "h2", level: "h2" } }, [
            _vm._v(_vm._s(_vm.title)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "box",
        { staticClass: "_grow-1 _flex", attrs: { content: !_vm.isEmpty } },
        [
          _c(
            "div",
            { class: _vm.stackSeparatedClasses },
            [
              !_vm.isLoading
                ? [_vm._t("default")]
                : [
                    _c(
                      "div",
                      {
                        attrs: { "data-qa": "backer-center-section:Skeleton" },
                      },
                      _vm._l(5, function (n) {
                        return _c("backer-center-preview-skeleton", { key: n })
                      }),
                      1
                    ),
                  ],
              _vm._v(" "),
              _vm.isEmpty && !_vm.isLoading
                ? _c(
                    "empty-state",
                    {
                      attrs: {
                        "show-divider": false,
                        "data-qa": "empty-state",
                      },
                    },
                    [
                      _c("base-text", { attrs: { level: "b2" } }, [
                        _vm._v(_vm._s(_vm.emptyTitle)),
                      ]),
                      _vm._v(" "),
                      _c("base-text", { attrs: { level: "b2" } }, [
                        _vm._v(_vm._s(_vm.emptyDescription)),
                      ]),
                      _vm._v(" "),
                      _vm.hasEmptyAction
                        ? _c(
                            "icon-base-button",
                            {
                              staticClass: "_mt-3",
                              attrs: {
                                tag: "a",
                                "empty-state": "",
                                href: _vm.searchUrl,
                                icon: "search",
                                theme: "accent",
                              },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.Resources.BackerCenter
                                      .UpdatesFeedEmptyStateButtonLabel
                                  ) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _vm.isMoreVisible
        ? _c(
            "div",
            { staticClass: "_tar" },
            [
              _c(
                "icon-link",
                {
                  staticClass: "_tc--accent",
                  attrs: {
                    href: _vm.linkMore,
                    icon: "chevron-right",
                    "icon-position": "after",
                    "data-qa": "backer-center-view-more",
                  },
                },
                [
                  _vm._v(
                    "\n            " + _vm._s(_vm.labelMore) + "\n        "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }